import React from "react";
import { useState } from "react";

import toggle from "./../../images/new/meme/toggle.svg";

const CustomDropdown = ({
  options,
  value,
  setValue,
  extraClass,
  mainState,
  customFunction,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectOption = (option) => {
    if (customFunction && mainState) {
      customFunction(mainState, setValue, option);
    } else {
      setValue(option);
    }
    toggleDropdown();
  };

  return (
    <>
      {value && (
        <div
          className={`customDropdown customInput ${isOpen ? "open" : ""} ${
            extraClass ? extraClass : ""
          }`} style ={{maxWidth:"200px"}}
        >
          <div className="customDropdownSelected" onClick={toggleDropdown}>
            <div className="customDropdownValue">
              {value.image && <img src={value.image} alt="" />}
              <p>{value?.title}</p>
            </div>
            <img src={toggle} alt="Toggle" className="toggle" />
          </div>

          <div className="customDropdownMenu">
            <ul>
              {options.map((option, index) => (
                <li
                  key={index}
                  className="customDropdownOption"
                  onClick={() => {
                    selectOption(option);
                  }}
                >
                  <p>{option?.title}</p>
                  <p className="description">{option?.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomDropdown;
